import React from 'react'

import { cn } from '@/lib/ui/style-helpers'

type IconPosition = 'start' | 'end'

export type TextWithIconProps = {
  text: string | React.ReactNode
  icon?: React.ReactNode
  iconPosition?: IconPosition
  /**
   * When true, the component will size to its content (fit-content).
   * When false, it will allow shrinking within flex containers and support truncation.
   */
  fit?: boolean
  textClassName?: string
} & React.HTMLAttributes<HTMLDivElement>

export const TextWithIcon = ({
  text,
  icon,
  iconPosition = 'start',
  fit = true,
  textClassName,
  ...props
}: TextWithIconProps) => {
  return (
    <div
      {...props}
      className={cn(
        'flex items-center gap-1 whitespace-nowrap',
        fit ? 'w-fit' : 'min-w-0 max-w-full overflow-hidden',
        { 'flex-row-reverse': iconPosition === 'end' },
        props.className,
      )}
    >
      {icon}
      <span className={textClassName}>{text}</span>
    </div>
  )
}
